/**
 * tm/components/JudgeSelect.tsx — 단계 「결과」 말 고르기 (2026-10-28 지도사 「통과 · 완료 · 진행 · 승인 이런 용어가 하드코딩되면 안 돼 · 업무 종류가 많고 내가 단계를 추가할 수도」)
 *  없음(그냥 ✓ 완료) · 승인/미승인 · 선정/미선정 · 통과/미통과 · 합격/불합격 · 직접(두 낱말)
 *  고르면 이 단계를 끝낼 때 「✓ 승인」 「미승인」 두 단추가 나오고 · 고객 · 팀장님 화면에도 그 말로 · 설정 › 업무 템플릿 · 업무 단계 편집 · 대출 점검 단계 편집이 같이 쓴다
 */
import { useState } from 'react';
import type { CSSProperties } from 'react';

export interface Judge { yes: string; no: string }
const PRESETS: Judge[] = [{ yes: '승인', no: '미승인' }, { yes: '선정', no: '미선정' }, { yes: '통과', no: '미통과' }, { yes: '합격', no: '불합격' }];
const keyOf = (j: Judge | null | undefined) => (j && j.yes ? `${j.yes}/${j.no}` : '');

export default function JudgeSelect({ value, onChange, width = 104, style }: { value: Judge | null | undefined; onChange: (j: Judge | null) => void; width?: number; style?: CSSProperties }) {
  const k = keyOf(value);
  const preset = PRESETS.some(p => keyOf(p) === k);
  const [custom, setCustom] = useState(!!k && !preset);
  const on = !!k;
  const sel: CSSProperties = { width, flexShrink: 0, padding: '6px 6px', borderRadius: 6, border: `1px solid ${on ? '#16653455' : '#E5E7EB'}`, fontSize: 11, color: on ? '#166534' : '#6B7280', background: on ? '#F0FDF4' : '#fff', fontWeight: 600, cursor: 'pointer', outline: 'none', boxSizing: 'border-box', ...style };
  if (custom) {
    const inp: CSSProperties = { width: 48, padding: '6px 4px', borderRadius: 6, border: '1px solid #16653455', fontSize: 11, textAlign: 'center', outline: 'none', boxSizing: 'border-box' };
    return (
      <span title="이 단계 결과 말 — 앞은 된 것 · 뒤는 안 된 것" style={{ display: 'inline-flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
        <input value={value ? value.yes : ''} maxLength={6} placeholder="가결" aria-label="된 결과 말" onChange={e => onChange({ yes: e.target.value, no: value ? value.no : '' })} style={inp} />
        <span style={{ color: '#9CA3AF', fontSize: 11 }}>/</span>
        <input value={value ? value.no : ''} maxLength={6} placeholder="부결" aria-label="안 된 결과 말" onChange={e => onChange({ yes: value ? value.yes : '', no: e.target.value })} style={inp} />
        <button type="button" aria-label="결과 말 고르기로" onClick={() => { setCustom(false); onChange(null); }} style={{ border: 'none', background: 'none', color: '#9CA3AF', cursor: 'pointer', fontSize: 11, padding: '0 2px' }}>✕</button>
      </span>
    );
  }
  return (
    <select value={k} aria-label="결과 단계" title="이 단계에서 결과(승인 · 선정 …)를 받나요? — 고르면 끝낼 때 두 단추로 결과를 적어요" style={sel}
      onChange={e => { const v = e.target.value; if (v === '__custom') { setCustom(true); onChange(value || { yes: '', no: '' }); return; } const p = PRESETS.find(x => keyOf(x) === v); onChange(p || null); }}>
      <option value="">결과 없음</option>
      {PRESETS.map(p => <option key={keyOf(p)} value={keyOf(p)}>{p.yes} · {p.no}</option>)}
      <option value="__custom">직접 적기…</option>
    </select>
  );
}
